module.exports = __webpack_public_path__ + "img/ivy-profilepix.22a80167.jpg";